<template>
  <div v-if="currentMembers.length > 0">
    <div class="row">
      <div class="col-12">
        <label :for="'current-'+memberType+'-members'">Current {{labelName}} Members:</label>
        <div :id="'current-'+memberType+'-members'" class="current-member-row row scroll-container">
          <div v-for="(member,index) in currentMembers" :key="member.uugid"
               v-if="index <= numberOfMembersToDisplay - 1"
               class="col-6 col-lg-4 current-member">
            <div class="sm-bordered-container">
              <span class="member-main-attribute align-bottom">{{member[mainAttribute]}}</span>
              <div class="d-none d-md-block group-uugid small">{{member[secondaryAttribute]}}</div>
            </div>
          </div>
          <!-- Don't show-->
          <div v-if="currentMembers.length > defaultNumberToShow" class="col-12 col-md-6 col-lg-4 show-toggle">
            <button class="btn btn-sm btn-outline-primary"
                    @click="showAll = !showAll">
              {{showAll ? 'Show less' : 'Show all'}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'CurrentMembers',
  props: {
    currentMembers: {
      type: Array,
      required: true,
    },
    memberType: {
      type: String,
      required: true,
      validator(value) {
        return ['org', 'person', 'group'].indexOf(value) !== -1;
      },
    },
    mainAttribute: {
      type: String,
      default: 'uugid',
    },
    secondaryAttribute: {
      type: String,
      default: 'displayName',
    },
    defaultNumberToShow: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    labelName() {
      if (this.memberType.toLowerCase() === 'org') {
        return 'Organizational';
      }
      if (this.memberType.toLowerCase() === 'person') {
        return 'Person';
      }
      if (this.memberType.toLowerCase() === 'group') {
        return 'Group';
      }
      return '';
    },
    numberOfMembersToDisplay() {
      if (this.showAll) {
        return this.currentMembers.length;
      }
      return this.defaultNumberToShow;
    },
  },
};
</script>

<style scoped>
  @media (min-width: 768px) {
    .show-toggle {
      padding-top: .25em;
      padding-bottom: .25em;
    }
    .show-toggle > button {
      margin-top: 0.25em;
    }
  }
  @media (max-width: 767px) {
    .show-toggle {
      margin-bottom: .25em;
      margin-top: .25em;
    }
    .sm-bordered-container {
      height: 100%;
      border-top: 1px solid #861f41;
    }
  }
  .current-member-row {
    padding-left: 0.5em;
  }
  .current-member {
    padding-bottom: 0.25em;
    opacity: 0.6;
  }
  .member-main-attribute {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/add-members/CurrentMembers.vue